import { Component, inject, ViewChild } from '@angular/core';
import { CurrencyPipe, CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';

import { ReceivableSearchService } from '../receivable-search.service';
import { ReceivableDomain } from '../domain/receivable-domain';
import { PaymentSearchModalComponent } from '../payment-search-modal/payment-search-modal.component';
import { PaymentService } from '../payment.service';

import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSortModule, MatSort} from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import { MatInputModule} from '@angular/material/input';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatSelectModule} from '@angular/material/select';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EditAmountDueModalComponent } from '../edit-amount-due-modal/edit-amount-due-modal.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { Account } from '@ohioepa/oepa-ebiz-lib';
import { MatSnackBar } from '@angular/material/snack-bar';

const action_EditAmountDue:       any = { title: "EDIT Amount Due",               className: 'material-icons edit'};
const action_RemoveReceivable:    any = { title: "REMOVE Receivable From List",   className: 'material-icons delete'};

@Component({
  selector: 'app-receivable-search-results',
  standalone: true,
  imports: [CurrencyPipe, CommonModule, MatFormFieldModule, MatInputModule, MatMenuModule,
    MatButtonModule, MatCardModule, MatTableModule, MatSortModule, MatPaginatorModule, MatDialogModule, MatSelectModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './receivable-search-results.component.html',
  styleUrl: './receivable-search-results.component.css',
  providers: []
})
export class ReceivableSearchResultsComponent {
  receivables: ReceivableDomain[] = [];
  receivableType: string = '';
  receivableTypeCode: string = '';
  totalBalanceDue: number = 0;
  readonly dialog = inject(MatDialog);
  dataSource : MatTableDataSource<ReceivableDomain>;
  sortedData : ReceivableDomain[] = [];
  displayedColumns: string[] = ['id', 'typeDesc', 'paymentOwner', 'balanceDue', 'dueDate', 'actions'];
  actions: string[] = ['1', '2', '3'];
  public account: Account | undefined;
  private _snackBar = inject(MatSnackBar);

  @ViewChild(MatTable) table!: MatTable<ReceivableDomain>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private router: Router,
    private route: ActivatedRoute, 
    private receivableSearchService: ReceivableSearchService,
    private paymentService: PaymentService
  ) {
    this.receivables = this.receivableSearchService.getReceivableList();
    this.totalBalanceDue = this.receivableSearchService.getTotalBalanceDue();
    this.receivableType = this.receivableSearchService.getReceivableTypeDesc();
    this.receivableTypeCode = this.receivableSearchService.getReceivableTypeCode();
    this.account = this.paymentService.getAccount();
    
    this.dataSource = new MatTableDataSource(this.receivables);
    this.sortedData = this.receivables.slice();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public getActionsForItem(receivable: ReceivableDomain) {
    const actionList: Array<any> = [];

    if (receivable.isZeroRevenue && receivable.balanceDue == 0) {
      actionList.push(action_EditAmountDue);
    }
    actionList.push(action_RemoveReceivable);
    
    return actionList;
  }

  public onActionClicked(rowData: ReceivableDomain, action: any): void {
    switch (action.title) {
      case action_EditAmountDue.title:
        console.log('edit amount due for receivable: ' + rowData.id);
        this.editAmountDue(rowData);
        break;
      case action_RemoveReceivable.title:
        console.log('remove receivable: ' + rowData.id);
        this.deleteRow(rowData);
        break;
    }
  }

  addAnother() {
    const dialogRef = this.dialog.open(PaymentSearchModalComponent, {
      // data: {name: this.name(), animal: this.animal()},
    });

    dialogRef.afterClosed().subscribe((receivable: ReceivableDomain) => {
      console.log('The dialog was closed');
      if (receivable) {
        this.dataSource = new MatTableDataSource(this.receivables);
        this.totalBalanceDue = this.receivableSearchService.getTotalBalanceDue();
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.table.renderRows();
      }
    });
  }

  editAmountDue(receivable: ReceivableDomain) {
    const confirmationDialogRef = this.dialog.open(ConfirmationDialog, {
      disableClose: false
      // data: {name: this.name(), animal: this.animal()},
    });
    confirmationDialogRef.componentInstance.confirmMessage = 
      'You have requested to update the revenue ' + receivable.id + '. Confirm you are making a payment?' ;

    confirmationDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const dialogRef = this.dialog.open(EditAmountDueModalComponent, {
          ariaLabelledBy: 'editAmountDueDialogTitle',
          data: {receivable: receivable},
        });
    
        dialogRef.afterClosed().subscribe((receivable: ReceivableDomain) => {
          console.log('The dialog was closed');
          if (receivable) {
            this.dataSource = new MatTableDataSource(this.receivables);
            this.totalBalanceDue = this.receivableSearchService.getTotalBalanceDue();
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.table.renderRows();
          }
        });
      }
    });
  }
  
  public deleteRow(receivable: ReceivableDomain) {
    this.receivableSearchService.removeReceivableFromList(receivable);
    this.receivables = this.receivableSearchService.getReceivableList();
    this.dataSource = new MatTableDataSource(this.receivables);
    this.totalBalanceDue = this.receivableSearchService.getTotalBalanceDue();
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.table.renderRows();
    // handleClose();
  };

  isPaying = false;

  pay() {
    this.isPaying = true;
    this.paymentService.submitReceivablesForPayment(this.receivables).subscribe({
      next: paymentTransaction => {
        this.paymentService.setPaymentTransaction(paymentTransaction);
        this.paymentService.retrieveInitialPaymentParametersForTransaction(paymentTransaction).subscribe({
          next: paymentParameters => {
            this.paymentService.setPaymentParameters(paymentParameters);
            this.router.navigate(['fee-payment-options'], { relativeTo: this.route.parent});
            this.isPaying = false;
          }, error: err => {
            const message = err.error.message || err.message || JSON.stringify(err);
            this._snackBar.open(message, 'error', { panelClass: ['mat-toolbar', 'red-snackbar']});
            this.isPaying = false;
          }})
      }, error: err => {
        const message = err.error.message || err.message || JSON.stringify(err);
        this._snackBar.open(message, 'error', { panelClass: ['mat-toolbar', 'red-snackbar']});
        this.isPaying = false;
      }});
  }

  startOver() {
    this.receivableSearchService.clearReceivableList();
    this.router.navigate(['payment-home'], { queryParams: {uid: this.account?.userID}, relativeTo: this.route.parent});
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getTotalAmountDue() {
    return this.receivables.map(t => t.balanceDue).reduce((acc, value) => acc + value, 0);
  }
}
